// export const settings_api = 'https://dnt.techno-content.com/eopt_api_for_rpe_tn';
// export const settings_api_2 = 'https://dnt.techno-content.com/eopt_api_for_rpe_tn';
// export const settingsApi = 'https://dnt.techno-content.com/eopt_api_v2_tn_for_hedget';
// export const settingsApi2 = 'https://dnt.techno-content.com/eopt_api_v2_tn_for_hedget';
// export const settingsApi = 'https://dnt.techno-content.com/eopt_v2_backend_wf_mn';

import { tTokenInfo } from "./interfaces/interfaces";

// export const settingsApi2 = 'https://dnt.techno-content.com/eopt_v2_backend_wf_mn';
export const settingsApi = 'https://dnt.techno-content.com/eopt_v2_backend_chr_tn';	// api and config not used in chr, so api not used
export const settingsApi2 = 'https://dnt.techno-content.com/eopt_v2_backend_chr_tn';	// api and config not used in chr, so api not used

// export const settings_api = 'https://ovh3.techno-content.com:33443/eopt_api_v2';    // prod main
// export const settings_api_2 = 'https://ovh9.techno-content.com/eopt_api_v2';    // prod reserv

// export const settingsApi = 'https://dnt.techno-content.com/eopt_api_v2_tn_for_hedget';   // chromia back
// export const settingsApi2 = 'https://dnt.techno-content.com/eopt_api_v2_tn_for_hedget';   // chromia back
// export const settings_api = 'https://ovh9.techno-content.com/eopt_chromia_api';   // chromia back
// export const settings_api_2 = 'https://ovh9.techno-content.com/eopt_chromia_api';   // chromia back

// export const basename = '/eopt_rpe_sbd/';
// export const basename = '/exchange/bscbeta5/';
// export const basename = '/eopt_chr/';
// export const basename = '/dapp/';
// export const basename = '/eopt-static/';
// export const basename = '/devnet/';
// export const basename = '/exchange/bscbeta5a/';
// export const basename = '/exchange/chr_beta1/';
// export const basename = '/wf/';
// export const basename = '/test/';
export const basename = '/./';
// export const basename = '/s3/';
// export const basename = '/s3_2/';

export const chainID: '0x38' | '0x61' | '181' = '181';    // 0x38 - mn, 0x61 - tn, 181 - wf
export const enableSettingsPage: boolean = false;
export const showRedux: boolean = true;   // set false in prod
export const version: string = 'v1.11';
export const disableUIBlocikng: boolean = false;      // true for exclusive version
export const getApiBalancerOn: boolean = false;
export const isDebugSigner: boolean = true;       // false in prod
export const isStaticTime: boolean = false;       // false in prod
export const sendUserLog: boolean = true;	// s3 - false
export const useBackendForBestChrUrl: boolean = false;	// s3 - false

export const blockchain: 'binance' | 'chromia' = 'chromia';

export const KasUrl = 'https://dnt.techno-content.com/front_kas/';
export const projectName = 'EOPT_CHR';
export const isProduction = false;

// export const monitorUrl = 'https://dnt.techno-content.com/monitor/accounts';	// old
export const monitorUrl: string = 'https://zomma.finance/monitor_s3';	// s3_2

////////////    CHROMIA    ////////////

export const isRegistrationAvailable: boolean = true; // s3 - false

/* export const chromia_bc = {
	// node_api_url: 'https://hedget.com/demo/node/',
	node_api_url: 'https://chromia.techno-content.com:10443/bc/',
	rid: '550A5ABBF7A8EE4B44EE42E736392AE69F0982639AC31AE1905154C26C99B27E',
	auth_url: 'https://hedget.com/demo/auth',  // their
	// auth_url: 'http://192.168.50.83/auth',    // our
} */

// not used in s3
// export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/dex_backend_chr_tn';	// devnet registration
// export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/dex_backend_chr_devnet_tn';	// devnet registration
// export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/dex_backend_chr_local_tn';	// local registration
// export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/dex_backend_tn';	// test registration
// export const chromiaBackendUrl = 'https://dnt.finance/register_chr_mn/';	// mainnet, change
// export const chromiaBackendUrl = 'https://guar.finance/register_chr_mn_v2';	// mainnet without check, change
export const chromiaBackendUrl = 'https://zomma.finance/register_chr_tn_s3';	// s3_2

// export const chromiaBlockchainRID = '4AEB5DE8F71A6D6614CCAC582B45931A8A2FB94440810945132EEE3BD231A688';	// quest net
// export const chromiaBlockchainRID = 'D89421A2F660582360C1CBF3E6B22CA2B43C54B18C191021B307AD80321A3DE9';	// dev net
// export const chromiaBlockchainRID = 'D8438972C98D9BA6713E9078387F38ECE4E2DBD303870E4E65F160C41A71F63A';	// local
// export const chromiaBlockchainRID = 'E86C0E9EBB8D10A697EAD7DB8AC3C531C72C57C79977DD9044377EAA17C125BE';	// test
// export const chromiaBlockchainRID = "FADAD11D04DC81171DA074E67934513F39FA6AFDF5CDFF023F981319BD5B0A47" // mainnet
// export const chromiaBlockchainRID = "AA489BA3432C686F29CC80655289219B88C24AF025711472CA736CAC25780742" // s3
export const chromiaBlockchainRID = "DDB913FA10D9519A2DDE50D8D154F8C1A11545CE269BAAF7438F7A0E195D5DB2" // s3_2

/* export const chromiaBlockchainUrl = [	// quest
	"https://node0.questnet.chromia.dev:7740",
	"https://node1.questnet.chromia.dev:7740",
	"https://node2.questnet.chromia.dev:7740",
	"https://node3.questnet.chromia.dev:7740"
] */
/* export const chromiaBlockchainUrl = [	// dev net
	"https://node4.devnet1.chromia.dev:7740",
	"https://node5.devnet1.chromia.dev:7740",
	"https://node6.devnet1.chromia.dev:7740"
	// "https://node7.devnet1.chromia.dev:7740",
]; */
/* export const chromiaBlockchainUrl = [	// local
	// "http://chromia.techno-content.com:7741",
	"https://chromia.techno-content.com:10443/bc_2/",
]; */
/* export const chromiaBlockchainUrl = [	// test
	'https://chromia.techno-content.com:10443/bc/'
]; */
/* export const directoryNodeUrlPool = [	// mainnet
	"https://dapps0.chromaway.com",
	"https://chromia-mainnet.w3coins.io:7740",
	"https://mainnet-dapp1.sunube.net:7740",
	"https://chromia.01node.com:7740",
	"https://chromia-mainnet.caliber.build:443",
	"https://chromia.nocturnallabs.org:7740",
	"https://chromina-node.stablelab.xyz:7740",
]; */
/* export const directoryNodeUrlPool = [	// s3
	"https://chromia.techno-content.com:10443/bc"
]; */
export const directoryNodeUrlPool = [	// s3_2
	"https://ovh13.techno-content.com:10443"
];
/* export const directoryNodeUrlPool = [
	"https://chromia.01node.com:7740",
]; */

export const backendForBestChrUrl = "https://ovh14.techno-content.com/node_load_balancer/node-full";

/* export const chrTokens: tTokenInfo[] = [
	{
		currency: 'USDT',
		// currency: 'USD',
		address: "efb1800647d4f7fb4150995e45b877061db5508c32bb855b1d5c5ddd8919c776",
		decimals: 18,
		showDecimals: 2,
		type: 'funding',
		contract: undefined as any
	},
	{
		currency: 'BTC',
		address: "7f220d9cff01bea14cde14d49b77bcb664417c18838e43501fb7b8014b9da6fc",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'ETH',
		address: "819325049ffc6b2cf0f3896c43c207c1e0da066b7a4ea798d07c69fa1ddd6c8e",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'CHR',
		address: "c43f69986fbf454c24ca894b6c78f34a3418c5faa74959bcc532c3624082c7bc",
		decimals: 12,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'Comission token',
		address: "c43f69986fbf454c24ca894b6c78f34a3418c5faa74959bcc532c3624082c7bc",
		decimals: 12,
		showDecimals: 3,
		type: 'commission',
		contract: undefined as any
	}
] */
/* export const chrTokens: tTokenInfo[] = [
	{
		currency: 'USDT',
		// currency: 'USD',
		address: "efb1800647d4f7fb4150995e45b877061db5508c32bb855b1d5c5ddd8919c776",
		decimals: 18,
		showDecimals: 2,
		type: 'funding',
		contract: undefined as any
	},
	{	
		currency: 'BNB',
		address: "4fdc1081189951b40e7b72bfe651af7a685ce8ca891f4c077d59c409d5f72d71",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'ETH',
		address: "819325049ffc6b2cf0f3896c43c207c1e0da066b7a4ea798d07c69fa1ddd6c8e",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'BTC',
		address: "7f220d9cff01bea14cde14d49b77bcb664417c18838e43501fb7b8014b9da6fc",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'CHR',
		address: "c43f69986fbf454c24ca894b6c78f34a3418c5faa74959bcc532c3624082c7bc",
		decimals: 12,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'Comission token',
		address: "c43f69986fbf454c24ca894b6c78f34a3418c5faa74959bcc532c3624082c7bc",
		decimals: 12,
		showDecimals: 3,
		type: 'commission',
		contract: undefined as any
	}
] */
/* export const chrTokens: tTokenInfo[] = [	// mainnet
	{
		currency: 'USDT',
		// currency: 'USD',
		address: "24a750d9f962d7d989b2c05fe3e570e106e16c030871bcb056ac5ca4a6acf77a",
		decimals: 18,
		showDecimals: 2,
		type: 'funding',
		contract: undefined as any
	},
	{	
		currency: 'BNB',
		address: "e14c3359d5ffc268d32b46b5ee9e982cbaa63e6cdf8a5d39b59a590181a785f6",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'ETH',
		address: "4a4c06c904ad2aeb4e1c8629ecbe4a227f6b4be529d2c7c97b6ed1b857b450f2",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'BTC',
		address: "436c58be826fa8106422034d721bdb3da05152476145b43d5259ec6436ced90a",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'CHR',
		address: "5949d87608a535ccdb987fcccf5b15dd3a09b734a974addf60367af0dfd2f5f0",
		decimals: 12,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'Comission token',
		address: "5949d87608a535ccdb987fcccf5b15dd3a09b734a974addf60367af0dfd2f5f0",
		decimals: 12,
		showDecimals: 3,
		type: 'commission',
		contract: undefined as any
	}
] */
/* export const chrTokens: tTokenInfo[] = [	// s3
	{
		currency: 'USDT',
		// currency: 'USD',
		address: "464b18c12cbaba17d4307bf2f6320188c3106d3ebf6397be2732a6a2b887343c",
		decimals: 18,
		showDecimals: 2,
		type: 'funding',
		contract: undefined as any
	},
	{	
		currency: 'BNB',
		address: "6bc9c5c1e304361f962a9520793486693e533d274cdfb4ebb8d45a01799380ab",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'ETH',
		address: "06d4c90a450da654d7abb14cce08ca70f0587e82101bca3ab0c5faa0ee1ec929",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'BTC',
		address: "f735d1e04f8a4f0b938cfb6045fd508bfdf6ca868819c9b45ab0533c6fd40e7b",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'CHR',
		address: "be32554e2094581bb5a0da532440378d82eb2ddc3b40f42b74711679ac956b66",
		decimals: 12,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'Comission token',
		address: "464b18c12cbaba17d4307bf2f6320188c3106d3ebf6397be2732a6a2b887343c",
		decimals: 18,
		showDecimals: 2,
		type: 'funding',
		contract: undefined as any
	}
	// {
	// 	currency: 'Comission token',
	// 	address: "be32554e2094581bb5a0da532440378d82eb2ddc3b40f42b74711679ac956b66",
	// 	decimals: 12,
	// 	showDecimals: 3,
	// 	type: 'commission',
	// 	contract: undefined as any
	// }
] */
export const chrTokens: tTokenInfo[] = [	// s3_2
	{
		currency: 'USDT',
		// currency: 'USD',
		address: "f752d406934c94aa7437fffc763db138b5619e9b73f2388a5128dac2d837dfc5",
		decimals: 18,
		showDecimals: 2,
		type: 'funding',
		contract: undefined as any
	},
	{	
		currency: 'BNB',
		address: "772473a401a8c2e28fee46aa072300246df1890a1af24b6b785d6387f713705c",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'ETH',
		address: "9a3ae0f0ff98fbcc132de6f97d469efaf32ecf093f8d669d2c5d1a7df776b3eb",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'BTC',
		address: "2645a0b485c26ef58521f8e224e78462d5cb7423e3b07764c8804d73db6c325c",
		decimals: 18,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'CHR',
		address: "c4476fe0a552eb2d80dcf0be5c99b23a04b0691e24c9781a3fcb171d9e58327f",
		decimals: 12,
		showDecimals: 3,
		type: 'underlying',
		contract: undefined as any
	},
	{
		currency: 'Comission token',
		address: "f752d406934c94aa7437fffc763db138b5619e9b73f2388a5128dac2d837dfc5",
		decimals: 18,
		showDecimals: 2,
		type: 'funding',
		contract: undefined as any
	}
	/* {
		currency: 'Comission token',
		address: "c4476fe0a552eb2d80dcf0be5c99b23a04b0691e24c9781a3fcb171d9e58327f",
		decimals: 12,
		showDecimals: 3,
		type: 'commission',
		contract: undefined as any
	} */
]